import api from './api-adapter';
import parseGame from './../util/parse-game';
// SAMPLE ID: 355824
import getParams from './../util/get-params';

export async function load (id, { markets = [ 'tr_1x2' ] } = {}) {
  const params = {
    market: markets.join(','),
    game_id: id,
    flat: 1
  };
  const { count, results: [ result ] } = await api.get('/game_odds/', { params });
  const { page } = getParams(window.location.href);
  if (result && new Date(result.date) < new Date() && page !== 'game') { window.location.href = '?'; }
  return count ? parseGame(result) : null;
}
